import { Icon } from '@iconify/react';
import CETWhite from 'assets/logo/cet_w.svg';
import { sanitize } from 'dompurify';
import Image from 'next/image';
import Link from 'next/link';
import { openCookieSettings } from 'utils/cookieConsent';

function Footer() {
  const FOOTER_LINKS = [
    {
      title: 'Homepagina',
      links: [
        {
          title: 'Home',
          href: '/'
        },
        // {
        //   title: 'Componenten',
        //   href: '/componenten'
        // },
        // {
        //   title: 'Functies',
        //   href: '/functies'
        // },
        {
          title: 'Demo',
          href: '/#demo'
        },
        {
          title: 'FAQ',
          href: '/faq'
        }
      ]
    },
    {
      title: 'Links',
      links: [
        {
          title: 'Contact',
          href: '/'
        },
        {
          title: 'Privacy reglement',
          href: '/privacy-reglement'
        },
        {
          title: 'Login',
          href: '/user/login'
        }
      ]
    }
  ];

  const EMAIL = 'info@cetrainer.nl'.replace(
    /[a-zA-Z]/g,
    (char) => `&#${char.charCodeAt(0)};`
  );
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-800 py-[40px] px-[20px] sm:py-[50px] sm:px-[40px] lg:py-[60px] lg:px-[100px]">
      <div className="flex flex-wrap justify-between gap-8   sm:gap-0">
        <div className="flex flex-col items-center justify-center sm:items-start sm:justify-normal gap-5 mx-auto sm:mx-0">
          <div className="w-[190px] sm:w-[100px] lg:w-[130px] xl:w-[170px] flex justify-center items-center">
            <Image
              src={CETWhite}
              alt="CET Logo"
              width={200}
              height={120}
              className="w-[190px] sm:w-[100px] lg:w-[130px] xl:w-[170px] h-auto"
            />
          </div>
          <div className="flex flex-col justify-center items-start gap-3">
            <div className="flex items-center text-white">
              <Icon
                icon="line-md:map-marker-filled"
                className="text-2xl mr-2"
              />
              <span className="font-semibold">Adres:</span>
              <span className="ml-2">Amsterdam, Nederland</span>
            </div>
            <div
              className="flex items-center text-white hover:cursor-pointer"
              onClick={() =>
                (window.location.href = `mailto:info@cetrainer.nl`)
              }
            >
              <Icon icon="weui:email-filled" className="text-2xl mr-2" />
              <span className="font-semibold">E-mail:</span>
              <span
                className="ml-3"
                dangerouslySetInnerHTML={{
                  __html: sanitize(EMAIL)
                }}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-start sm:items-start sm:justify-center gap-5">
          {/* <div>
            <h3 className="font-bold text-xl text-white">
              {FOOTER_LINKS[0].title}
            </h3>
          </div> */}
          <div>
            <ul className="flex flex-col justify-center items-start gap-5 sm:gap-4 xl:gap-6">
              {FOOTER_LINKS[0].links.map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className="text-white">
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col justify-start sm:items-start sm:justify-center gap-5">
          {/* <div>
            <h3 className="font-bold text-xl text-white">
              {FOOTER_LINKS[1].title}
            </h3>
          </div> */}
          <div>
            <ul className="flex flex-col justify-center items-start gap-5 sm:gap-4 xl:gap-6">
              {FOOTER_LINKS[1].links.map((link, index) => (
                <li key={index}>
                  <Link href={link.href} className="text-white">
                    {link.title}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  className="text-white"
                >
                  Cookie-instellingen
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="pt-10 mt-8 border-t border-primary text-center text-zinc-50">
        <p>Copyright © {year} door Praha. Alle rechten voorbehouden.</p>
      </div> */}
    </footer>
  );
}

export default Footer;
